/* - these constants are related to UI/customer-side to which screen we can prompt to based on the users login credentials  
   - these constants are set at the application level in BE.
*/
export enum CustomerSideNextScreenConstants {
  UPDATE_PASSWORD = 1,
  APPLICATION_LOGIN = 2,
  FORGOT_PASSWORD = 3
}

export enum DateFilterComponentOptions {
  LAST_N_DAYS = "1",
  CUSTOM_RANGE = "2"
}

export const enum DefaultPagination {
  PAGE = 1,
  PAGE_SIZE = 100
}

export const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export enum ApplicationModeConstants {
  DEVELOPMENT = "development",
  TEST = "test",
  UAT = "uat",
  PRODUCTION = "production"
}
